import { useState } from 'react';
import Modal from './Modal.jsx';
import ImageUpload from './ImageUpload.jsx';
import { apiCreateRecord, apiUpdateRecord } from '../api.js';

const EMPTY = { Code: '', Name: '', Tags: '', ImageUrl: '', ProductUrl: '', TutorialUrl: '' };

export default function RecordForm({ record, onSaved, onClose }) {
  const editing = !!record;
  const [form, setForm] = useState(record ? { ...record } : { ...EMPTY });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const inputCls = 'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500';
  const Field = ({ label, children }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      {children}
    </div>
  );

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (editing) await apiUpdateRecord(form.Id, form);
      else await apiCreateRecord(form);
      onSaved();
    } catch {
      setError(editing ? '修改失败，请稍后重试' : '保存出错');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title={editing ? '编辑款式' : '新增款式'} onClose={onClose}>
      <form onSubmit={submit} className="p-6 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <Field label="款号"><input required value={form.Code || ''} onChange={(e) => set('Code', e.target.value)} className={inputCls} /></Field>
          <Field label="名称"><input required value={form.Name || ''} onChange={(e) => set('Name', e.target.value)} className={inputCls} /></Field>
        </div>
        <Field label="标签 (关键字)"><input value={form.Tags || ''} onChange={(e) => set('Tags', e.target.value)} className={inputCls} /></Field>
        <Field label="图片链接"><ImageUpload value={form.ImageUrl} onChange={(v) => set('ImageUrl', v)} /></Field>
        <Field label="教程链接"><input value={form.TutorialUrl || ''} onChange={(e) => set('TutorialUrl', e.target.value)} className={inputCls} /></Field>
        <Field label="商品链接"><input value={form.ProductUrl || ''} onChange={(e) => set('ProductUrl', e.target.value)} className={inputCls} /></Field>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="pt-4 flex justify-end gap-3">
          <button type="button" onClick={onClose} className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">取消</button>
          <button type="submit" disabled={saving} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-60">{saving ? '保存中…' : '保存'}</button>
        </div>
      </form>
    </Modal>
  );
}
